/**
 * Chiziqli ikonkalar (prototip `index.html` SVG sprite'idan). 24×24 viewBox,
 * stroke = currentColor, fill yo'q (AppIcon.vue chizadi). Yangi ikonka —
 * shu uslubda (stroke 1.8, yumaloq uchlar) qo'shiladi.
 */
export const ICONS = {
  logo: '<path d="M4 4.5h6a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H4z"/><path d="M20 4.5h-6a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h6z"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/>',
  home: '<path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z"/>',
  grid: '<rect x="4" y="4" width="7" height="7" rx="2"/><rect x="13" y="4" width="7" height="7" rx="2"/><rect x="4" y="13" width="7" height="7" rx="2"/><rect x="13" y="13" width="7" height="7" rx="2"/>',
  layers:
    '<path d="m12 3 8 4.5-8 4.5-8-4.5z"/><path d="m4 12.5 8 4.5 8-4.5"/><path d="m4 16.5 8 4.5 8-4.5"/>',
  users:
    '<circle cx="9" cy="8" r="3.4"/><path d="M3.5 20c0-3 2.5-5 5.5-5s5.5 2 5.5 5"/><path d="M16 5.6a3.4 3.4 0 0 1 0 6.6M17 15c2.3.5 3.8 2.3 3.8 5"/>',
  bookmark: '<path d="M6 4.5h12v16l-6-4.2-6 4.2z"/>',
  /** O'qish sozlamalari (prototip reader.html `i-aa`) */
  aa: '<path d="M3 18 8 6l5 12M4.8 14h6.4"/><path d="M15 18l3.5-8 3.5 8M16.2 15.4h4.6"/>',
  maximize:
    '<path d="M4.5 9V5.5a1 1 0 0 1 1-1H9M15 4.5h3.5a1 1 0 0 1 1 1V9M19.5 15v3.5a1 1 0 0 1-1 1H15M9 19.5H5.5a1 1 0 0 1-1-1V15"/>',
  minimize:
    '<path d="M9 4.5V8a1 1 0 0 1-1 1H4.5M19.5 9H16a1 1 0 0 1-1-1V4.5M15 19.5V16a1 1 0 0 1 1-1h3.5M4.5 15H8a1 1 0 0 1 1 1v3.5"/>',
  clock: '<circle cx="12" cy="12" r="8.2"/><path d="M12 7.6V12l3.2 2"/>',
  download:
    '<path d="M12 4v10m0 0 3.6-3.6M12 14l-3.6-3.6"/><path d="M4.5 17.5V19a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-1.5"/>',
  upload:
    '<path d="M12 15V5m0 0 3.6 3.6M12 5 8.4 8.6"/><path d="M4.5 17.5V19a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-1.5"/>',
  star: '<path d="m12 3.6 2.6 5.5 6 .8-4.4 4.2 1.1 6L12 17.3l-5.3 2.8 1.1-6L3.4 9.9l6-.8z"/>',
  headphones:
    '<path d="M4.5 15v-3a7.5 7.5 0 0 1 15 0v3"/><rect x="3" y="14.5" width="4" height="6" rx="1.6"/><rect x="17" y="14.5" width="4" height="6" rx="1.6"/>',
  text: '<path d="M6.5 4h11a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/><path d="M9 8.5h6M9 12h6M9 15.5h3.5"/>',
  left: '<path d="M14.5 5.5 8 12l6.5 6.5"/>',
  right: '<path d="M9.5 5.5 16 12l-6.5 6.5"/>',
  down: '<path d="m6 9.5 6 6 6-6"/>',
  arrow: '<path d="M4.5 12h15m0 0-5.5-5.5M19.5 12 14 17.5"/>',
  back: '<path d="M19.5 12h-15m0 0 5.5-5.5M4.5 12 10 17.5"/>',
  shuffle:
    '<path d="M4 7h4l8 10h4"/><path d="M4 17h4l3-3.6"/><path d="M17 4l3 3-3 3"/><path d="M17 14l3 3-3 3"/>',
  sun: '<circle cx="12" cy="12" r="4.2"/><path d="M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6l1.4 1.4m10 10 1.4 1.4m0-12.8-1.4 1.4m-10 10L5.6 18.4"/>',
  moon: '<path d="M20 14.5A8.2 8.2 0 0 1 9.5 4 8.3 8.3 0 1 0 20 14.5z"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h12"/>',
  close: '<path d="m6 6 12 12M18 6 6 18"/>',
  chart:
    '<path d="M4 20h16"/><rect x="6" y="12" width="3.4" height="5.5" rx="1"/><rect x="11.3" y="8" width="3.4" height="9.5" rx="1"/><rect x="16.6" y="5" width="3.4" height="12.5" rx="1"/>',
  dots: '<circle cx="6" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="18" cy="12" r="1.6"/>',
  user: '<circle cx="12" cy="8.5" r="3.8"/><path d="M4.8 20c0-3.4 3.2-5.8 7.2-5.8s7.2 2.4 7.2 5.8"/>',
  help: '<circle cx="12" cy="12" r="8.4"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.6 2.3c-.8.4-1.2 1-1.2 1.9"/><circle cx="12" cy="17" r=".9" fill="currentColor" stroke="none"/>',
  crown: '<path d="M3.5 8l3.5 3L12 5l5 6 3.5-3-1.6 10.5H5.1z"/>',
  share:
    '<path d="M12 4v11m0-11 4 4m-4-4-4 4"/><path d="M5 14v4.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V14"/>',
  calendar:
    '<rect x="4" y="5.5" width="16" height="15" rx="2"/><path d="M4 10h16M8 3.5v4M16 3.5v4"/>',
  check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
  checkCircle: '<circle cx="12" cy="12" r="8.4"/><path d="m8.5 12.3 2.4 2.4 4.8-5"/>',
  xCircle: '<circle cx="12" cy="12" r="8.4"/><path d="m9.2 9.2 5.6 5.6m0-5.6-5.6 5.6"/>',
  alert: '<path d="M12 4.5 20.5 19h-17z"/><path d="M12 10v4m0 2.5v.5"/>',
  info: '<circle cx="12" cy="12" r="8.4"/><path d="M12 11v5m0-8v.5"/>',
  play: '<path d="M8 5.5v13l10-6.5z"/>',
  camera:
    '<path d="M4 8.5a1.5 1.5 0 0 1 1.5-1.5H8l1.4-2h5.2L16 7h2.5A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.4"/>',
  video:
    '<rect x="3.5" y="6.5" width="12" height="11" rx="2"/><path d="m15.5 10.5 5-2.5v8l-5-2.5"/>',
  edit: '<path d="M4 20h4l10.5-10.5a1.4 1.4 0 0 0 0-2L16.5 5.5a1.4 1.4 0 0 0-2 0L4 16z"/><path d="m13 7 4 4"/>',
  trash:
    '<path d="M5 7h14M9.5 7V4.5h5V7"/><path d="M6.5 7l.8 12a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4l.8-12"/><path d="M10 11v6m4-6v6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  minus: '<path d="M5 12h14"/>',
  file: '<path d="M7 3.5h7l5 5v11a1.5 1.5 0 0 1-1.5 1.5h-10.5A1.5 1.5 0 0 1 5.5 19.5V5A1.5 1.5 0 0 1 7 3.5z"/><path d="M14 3.5v5h5"/>',
  book: '<path d="M5 4.5h9a3 3 0 0 1 3 3v12H8a3 3 0 0 0-3 3z"/><path d="M5 4.5v18"/><path d="M17 19.5h2v-12"/>',
  list: '<path d="M8 6.5h12M8 12h12M8 17.5h12"/><circle cx="4.5" cy="6.5" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="17.5" r="1"/>',
  building:
    '<rect x="4.5" y="3.5" width="15" height="17" rx="1.5"/><path d="M8.5 7.5h2m3 0h2m-7 4h2m3 0h2m-7 4h2m3 0h2M10 20.5v-3h4v3"/>',
  eye: '<path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>',
  logout:
    '<path d="M10 4.5H6A1.5 1.5 0 0 0 4.5 6v12A1.5 1.5 0 0 0 6 19.5h4"/><path d="M14.5 8 18.5 12l-4 4M9 12h9.5"/>',
  timer: '<circle cx="12" cy="13" r="7.5"/><path d="M12 9v4.3l2.6 1.7M9.5 3.5h5M12 3.5v2"/>',
  refresh:
    '<path d="M4.5 12a7.5 7.5 0 0 1 12.9-5.2L19.5 9M19.5 12a7.5 7.5 0 0 1-12.9 5.2L4.5 15"/><path d="M19.5 4.5V9H15M4.5 19.5V15H9"/>',
  filter: '<path d="M4 6h16l-6.5 7.5v5L10 20v-6.5z"/>',
  award: '<circle cx="12" cy="9" r="5.5"/><path d="m8.5 13.5-1.5 7 5-2.5 5 2.5-1.5-7"/>',
  spark: '<path d="M12 3.5 13.8 9l5.7 1.8-5.7 1.8L12 18.4l-1.8-5.8L4.5 10.8 10.2 9z"/>',
  external:
    '<path d="M14 4.5h5.5V10"/><path d="M19.5 4.5 11 13"/><path d="M17.5 13.5V18a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18V8A1.5 1.5 0 0 1 6 6.5h4.5"/>',
  image:
    '<rect x="4" y="5" width="16" height="14" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="m4.5 17 4.5-4.5 3.5 3.5 2.5-2.5 4.5 4.5"/>',
  mic: '<rect x="9" y="3.5" width="6" height="10.5" rx="3"/><path d="M6 11.5a6 6 0 0 0 12 0M12 17.5v3M9 20.5h6"/>',
  donut: '<circle cx="12" cy="12" r="8.4"/><circle cx="12" cy="12" r="3.4"/>',
  radar:
    '<path d="M12 3.4 20.1 9.3 17 18.9H7L3.9 9.3z"/><path d="M12 8.2l4 2.9-1.5 4.7h-5L8 11.1z"/>',
  trend: '<path d="M4 16.5 9.5 11l3.5 3.5L20 7.5"/><path d="M15 7.5h5v5"/>',
  /* Rollar va ruxsatlar — qalqon + belgi */
  shield:
    '<path d="M12 3.5 19 6v6c0 4.2-2.9 7.3-7 8.5-4.1-1.2-7-4.3-7-8.5V6z"/><path d="m9.2 11.8 2 2 3.6-3.6"/>',
  /** Ochiq kitob — elektron kitob (PDF) fayli bor */
  bookOpen:
    '<path d="M12 7.5v13"/><path d="M3.5 5h4.8A3.7 3.7 0 0 1 12 8.7a3.7 3.7 0 0 1 3.7-3.7h4.8v13h-5.3a3.2 3.2 0 0 0-3.2 2.5 3.2 3.2 0 0 0-3.2-2.5H3.5z"/>',
  /** Test (kitob savollari) — planshet va belgi */
  quiz: '<rect x="8.5" y="3" width="7" height="3.5" rx="1"/><path d="M15.5 4.8h1.7a1.8 1.8 0 0 1 1.8 1.8v12.6a1.8 1.8 0 0 1-1.8 1.8H6.8A1.8 1.8 0 0 1 5 19.2V6.6a1.8 1.8 0 0 1 1.8-1.8h1.7"/><path d="m9 13.5 2.2 2.2 4-4.2"/>',
  /** Brauzer oynasi va o'ngdagi yon panel */
  sidebar:
    '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/><path d="M14.5 4.5v15M17 8.5h1M17 11.5h1"/>',
  /** Skrinshot — kadr burchaklari va obyektiv */
  screenshot:
    '<path d="M4 8V5.5A1.5 1.5 0 0 1 5.5 4H8M16 4h2.5A1.5 1.5 0 0 1 20 5.5V8M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H16M8 20H5.5A1.5 1.5 0 0 1 4 18.5V16"/><circle cx="12" cy="12" r="3"/>',
} as const;

export type IconName = keyof typeof ICONS;
